import React, { useEffect, useState } from "react";
import QandATable from "../../../../Components/Table/QandATable";
import { Box } from "@mui/material";
import Searchbar from "../../../../Components/Searchbar/Searchbar";
import { GetQuestions } from "../../../../APIs/Function/Workout/Q&A/GetQuestions";
import { Link } from "react-router-dom";
import CustomButton from "../../../../Components/Button/CustomButton";
import { SearchDebouncing } from "../../../../APIs/Search/SearchDebouncing";

const Questions = () => {
  const [QuestionsData, setQuestionsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchData, setSearchData] = useState([]);

  const handleQuestions = async () => {
    try {
      setLoading(true);
      let res = await GetQuestions();
      setQuestionsData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const handleSearch = async (e) => {
    const searchValue = e.target.value.trim();
    if (searchValue.length === 0) {
      setSearchData([]);
      setSearched(false);
      return;
    }
    try {
      await SearchDebouncing(7, searchValue, setSearchData);
      setSearched(true);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    handleQuestions();
  }, []);
  return (
    <>
      <Box sx={{ boxSizing: "border-box", p: 2 }}>
        {/* searchbar */}
        <Box>
          <Searchbar placeholder={"search"} onChange={handleSearch} />
        </Box>
        {searched && searchData.length > 0 ? (
          <QandATable
            data={searchData}
            setQuestionsData={setQuestionsData}
            loadinga={loading}
            Column1={"#"}
            Column2={"Questions"}
            Column3={"No of Options"}
            Column4={"Action"}
          />
        ) : !searched ? (
          <QandATable
            data={QuestionsData}
            setQuestionsData={setQuestionsData}
            loadinga={loading}
            Column1={"#"}
            Column2={"Questions"}
            Column3={"No of Options"}
            Column4={"Action"}
          />
        ) : (
          ""
        )}
        {/* <QandATable
          data={QuestionsData}
          setQuestionsData={setQuestionsData}
          loadinga={loading}
          Column1={"#"}
          Column2={"Questions"}
          Column3={"No of Options"}
          Column4={"Action"}
        /> */}
        <Box
          sx={{
            display: "flex",
            mt: "25px",
            justifyContent: "end",
            width: "100%",
          }}
        >
          <Link to={"/addquestion"}>
            <CustomButton
              sx={{
                width: "100%",
                bgcolor: "#31AEF4",
                "&:hover": {
                  bgcolor: "#31AEF4",
                },
              }}
            >
              ADD +
            </CustomButton>
          </Link>
        </Box>
      </Box>
    </>
  );
};

export default Questions;
